const getInstituteData = state => state?.settings?.instituteData
const getUniversityList = state => state?.settings?.universityList

const selectors = {
  getInstituteData,
  getUniversityList
}
export default selectors
